/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountNativeDetailsForVcenter extends models.ServiceAccountNativeDetailsBaseForCloud {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountNativeDetailsForVcenter");
    }

    getFixupPrototypeFunction() { return ServiceAccountNativeDetailsForVcenter.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountNativeDetailsForVcenter>): ServiceAccountNativeDetailsForVcenter {
        let obj = Object.assign(new ServiceAccountNativeDetailsForVcenter(), model);
        ServiceAccountNativeDetailsForVcenter.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountNativeDetailsForVcenter>): ServiceAccountNativeDetailsForVcenter {
        if (!model) return null;
        return ServiceAccountNativeDetailsForVcenter.newInstance(<ServiceAccountNativeDetailsForVcenter> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountNativeDetailsForVcenter) {
        if (!obj) return;

        models.ServiceAccountNativeDetailsForVcenter.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountNativeDetailsForVcenter): boolean {
        if (models.ServiceAccountNativeDetailsBaseForCloud.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountNativeDetailsForVcenter.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
